/**
 * Describes how the single validation item is displayed.
 */
export interface ValidationMessage {
  /**
   * Define the validation status of the message.
   */
  level: ValidationLevel;
  label?: string;
  message: string;
  parameters?: any;
  fields?: string[];
}

/**
 * Describes how the Validation component is displayed.
 */
export interface ValidationProps {
  /**
   * Define the primary validation status of component.
   */
  level: ValidationLevel;
  /**
   * Define list of validation message [[ValidationMessage]]. It consist of level and text message.
   */
  messages: ValidationMessage[];
  /**
   * Optional. Directly connecting the error to a domain by it's id.
   */
  domainId?: number;

  /**
   * Optional. Pass true to allow line breaks. Default is false.
   */
  enableMultilineValidation?: boolean;
}

/**
 * Describes different validation levels.
 */
export enum ValidationLevel {
  'success' = 1,
  'warning',
  'error'
}

export const createValidationErrors = (errors: string[]): ValidationProps => {
  return {
    level: ValidationLevel.error,
    messages: errors.map(error => ({ level: ValidationLevel.error, message: error }))
  };
};
